// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  outline: none;
}

body {
  font-family: "Inter";
  background-color: #f1f4f8;
  color: #4a4a4a;
  overflow-x: hidden;
}

main {
  padding-top: 100px;
  min-height: 1000px;
}

h5 {
  font-size: 20px;
  font-weight: 600;
}

p {
  font-size: 16px;
  line-height: 28px;
  font-weight: 500;
  color: #696868;
  margin-bottom: 10px;
}

.accordion {
  margin: 0 auto;
}

.accordion_item {
  margin-bottom: 15px;
}

.accordion_title {
  position: relative;
  padding: 24px 80px 24px 30px;
  background-color: transparent;
  border-bottom: 1px;
  cursor: pointer;
}

.accordion_title .pluscircle {
  position: absolute;
  right: 30px;
  top: 45%;
  transition: all ease 0.6s 0.5s;
}

.accordion_desc {
  padding: 30px;
  background-color: transparent;
  border-radius: 0 4px 20px rgba(0, 0, 0, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.07);
}

.accordion_item.active .pluscircle {
  transform: scale(-1) translateY(5px);
}

.accordion_item.active .accordion_title {
  border-radius: 16px 16px 0 0;
}

.pluscircle {
  display: none;
}

@media screen and (min-width: 1440px) {
  .heading-9 {
    font-size: 44px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/faq.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;EACA,aAAA;AACF;;AACA;EACC,oBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;AAED;;AAAA;EACE,kBAAA;EACA,kBAAA;AAGF;;AADA;EACE,eAAA;EACA,gBAAA;AAIF;;AAFA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAKF;;AAHA;EACE,cAAA;AAMF;;AAJA;EACE,mBAAA;AAOF;;AALA;EACE,kBAAA;EACA,4BAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;AAQF;;AANA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,8BAAA;AASF;;AAPA;EACE,aAAA;EACA,6BAAA;EACA,6CAAA;EACA,yCAAA;AAUF;;AARA;EACE,oCAAA;AAWF;;AATA;EACE,4BAAA;AAYF;;AAVA;EACE,aAAA;AAaF;;AAVE;EADF;IAEI,eAAA;EAcF;AACF","sourcesContent":["*{\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n  outline: none;\r\n}\r\nbody{\r\n font-family: 'Inter'; \r\n background-color: #f1f4f8;\r\n color: #4a4a4a;\r\n overflow-x: hidden;\r\n}\r\nmain{\r\n  padding-top: 100px;\r\n  min-height: 1000px;\r\n}\r\nh5{\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n}\r\np{\r\n  font-size: 16px;\r\n  line-height: 28px;\r\n  font-weight: 500;\r\n  color: #696868;\r\n  margin-bottom: 10px;\r\n}\r\n.accordion{\r\n  margin: 0 auto;\r\n}\r\n.accordion_item{\r\n  margin-bottom: 15px;\r\n}\r\n.accordion_title{\r\n  position: relative;\r\n  padding: 24px 80px 24px 30px;\r\n  background-color: transparent;\r\n  border-bottom: 1px;\r\n  cursor: pointer;\r\n}\r\n.accordion_title .pluscircle{\r\n  position: absolute;\r\n  right: 30px;\r\n  top: 45%;\r\n  transition: all ease 0.6s 0.5s;\r\n}\r\n.accordion_desc{\r\n  padding: 30px;\r\n  background-color: transparent;\r\n  border-radius: 0 4px 20px rgba(0,0,0,0.03);\r\n  border-top: 1px solid rgba(0,0,0,0.07);\r\n}\r\n.accordion_item.active .pluscircle{\r\n  transform: scale(-1) translateY(5px);\r\n}\r\n.accordion_item.active .accordion_title{\r\n  border-radius: 16px 16px 0 0;\r\n}\r\n.pluscircle{\r\n  display: none;\r\n}\r\n.heading-9{\r\n  @media screen and (min-width: 1440px){\r\n    font-size: 44px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
